import { useEffect, useState, useContext } from "react";
import {  useNavigate } from "react-router-dom";
import BASE_URL from "../../BaseUrl";
import "../../styles/admin/AdminProfile.css";
import { GlobalContext } from "../GlobalContext";

import axios from "axios";
import StarRating from "./StarRating";

export default function AdminProfile({active,setActive,setMobileActive}) {
    const navigate = useNavigate();
    const {admin, setAdmin} = useContext(GlobalContext);
    const [loaded , setLoaded] = useState(false);
    const [reload, setReload] = useState(false);
    const [showUpdateform,setShowUpdateForm] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [editAdmin,setEditAdmin] = useState(null);

    const [message, setMessage] = useState("error message");
    const [showMessage, setShowMessage] = useState(false);

    const [showUpdatePassword, setShowUpdatePassword] = useState(false);
    const [newPassword,setNewPassword] = useState({
        oldPassword:"",
        newPassword:"",
        confirmPassword:"",
    })
    const openEditForm = ()=>{
        setEditAdmin({...admin});
        setShowUpdateForm(true);
    }
    const [expiredAdminStyle,setExpiredAdminStyle] = useState({  // style for expire date field if the plan expired or will expire soon
        color:"",
        borderColor:""
    })

    const isExpired = (date)=>{
        if(new Date(date) < new Date()){
            setExpiredAdminStyle({color:"red",borderColor:"red"});
            return;
        }
        if(new Date(date).setDate(new Date(date).getDate()-7) < new Date()){
            setExpiredAdminStyle({color:"orange",borderColor:"orange"});
        }

    }
    
    const fetchData = async () => {
            let admin2 = admin;
            await axios.get(`${BASE_URL}/teacher/get-admin-by-token`, { withCredentials: true })
                .then((response) => {
                    admin2 = response.data;
                    setLoaded(true);
                }).catch((error) => {
                    navigate("/"); // Redirect to login if admin data is not availabel
                })

            await axios.get(`${BASE_URL}/teacher/courses?adminId=${admin2.id}`, { withCredentials: true })
            .then((response) => {
                setAdmin({...admin2, courses: response.data});
                setLoaded(true);
                
            }).catch((error) => {
                console.error("Error fetching course data:", error);
                navigate("/");
                // Handle error appropriately, e.g., show a notification or redirect
            })
        
    }

    const deleteAdmin = () => {
        axios.delete(`${BASE_URL}/teacher/delete-account`, { withCredentials: true })
            .then((response) => {
                navigate("/");
            }).catch((error) => {
                console.log(error);
            })
        }

    const updateAdmin = ()=>{
        axios.put(`${BASE_URL}/teacher/update-admin-info`,editAdmin,{withCredentials: true})
        .then((response)=>{
            setShowUpdateForm(false);
            setAdmin({...editAdmin});
        }).catch((error)=>{
            console.log(error);
            setShowUpdateForm(false);
        })
    }

    const deleteRegisteredStudents = ()=>{
        axios.get(`${BASE_URL}/teacher/clearStudents`,{withCredentials:true}).then((response)=>{
            setReload(!reload);
        }).catch((error)=>{
            navigate("/");
        })
    }

    async function updatePassword(){
        if(newPassword.oldPassword === "" || newPassword.newPassword === "" || newPassword.confirmPassword === "" ){
            setMessage("يجب ملئ جميع الحقول");
            setShowMessage(true);
            return;
        }
        if(newPassword.newPassword !== newPassword.confirmPassword){
            setMessage("تأكيد كلمة المرور غير متطابق");
            setShowMessage(true);
            return;
        }
        const newpassword = newPassword.newPassword;
        const oldPassword = newPassword.oldPassword;
        try{
            const response = await axios.put(`${BASE_URL}/teacher/update-password`,{oldPassword,newpassword},{withCredentials:true});
            setMessage(response.data);
            setShowMessage(true);
        }catch(error){
            if(error.response.status === 403){
                setMessage(error.response.data);
                setShowMessage(true);
            }
            else{
                console.log(error);
            }
        }

    }

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        
        const formData = new FormData();
        formData.append("file", file);
        formData.append("adminId", admin.id);
    
        try {
          await axios.post(
            `${BASE_URL}/teacher/change-photo`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              }, withCredentials: true
            }
          ).then(()=>{
            setReload(!reload);
          });
        } catch (err) {
          console.error(err);
          alert("Upload failed");
        }
      };


    useEffect(() => {
        setActive("الملف الشخصي");
        setMobileActive("profile mobile");
        fetchData();
        isExpired(admin.expire);
    }, [reload])
    return (
        loaded&&<div className="admin-profile-nav-container">
            <div className="admin-profile-container">
                <div className={`advanced-links-motion ${active==="الملف الشخصي"?"advanced-links-in":"advanced-links-out"}`}>
                <div className="advanced-links">
                    <label onClick={() => { navigate("/admin-home/admin-assistants")}}>👨‍🎓المساعدين</label>
                    <br />
                    <br />
                    <label onClick={openEditForm}> 🔄تحديث البيانات</label>
                    <br />
                    <br />
                    <label onClick={()=>setShowUpdatePassword(true)}>🔒تغير كلمة المرور</label>
                    <br />
                    <br />
                    <label onClick={()=>navigate("/admin-home/plans")}>⏫إشتراك/ترقية</label>
                    <br />
                    <br />
                    <label onClick={()=>{window.open("https://wa.me/201030452252", "_blank")}}>👨🏻‍💼تواصل مع المالك</label>
                    <br />
                    <br />
                    <label className="delete-account-button" onClick={()=>{setShowDeletePopup(true)}}>🗑️حذف الحساب</label>
                </div>
                </div>
                <div className={`admin-profile-motion ${active==="الملف الشخصي"?"admin-profile-in":"admin-profile-out"}`}>
                    <div className="admin-profile">
                        <h2>الملف الشخصي</h2>
                        <div className= "admin-photo-div">
                            <div style={{width:"150px",height:"150px"}}>
                            <img
                            src={
                            `${BASE_URL}/teacher/admin-image?adminId=${admin.id}&ext=${admin.imageExt}&t=${reload}` 
                            }
                            alt="avatar"
                            className="avatar"
                            />
                            </div>
                        <label
                            style={{width:"100%", justifyItems:"right",textAlign:"right", display:"block"}}
                            >
                            <div
                                className="camera"
                            >
                                📷
                            </div>
                            <input
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                            />
                            </label>
                            <StarRating rate={admin.rate} />
                            <div style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
                            <h6>التقييمات {admin.numberOfRates}</h6>
                                <h6>التقييم {admin.rate}</h6>
                            </div>
                        </div>
                        <label>الاسم</label>
                        <input type="text" value={admin.name} readOnly />
                        <label>البريد الإلكتروني</label>
                        <input type="text" value={admin.email} readOnly />
                        <label>رقم الهاتف</label>
                        <input type="text" value={admin.phone} readOnly />
                        <label>التخصص</label>
                        <input type="text" value={admin.field} readOnly />
                        <label>عدد الدروس</label>
                        <input type="text" value={`${(admin.usedCapacity)}/${admin.capacity}`} readOnly />
                        
                        <button className="delete-all-registerd-students"
                            onClick={deleteRegisteredStudents}
                        >مسح الطلاب المسجلين</button>

                        <button className="delete-all-registerd-students"
                            onClick={() => navigate("/admin-home/admin-students")}
                        >الطلاب</button>
                        <label>عدد الطلاب </label>
                        <input type="text" value={`${admin.currentStudent}/${admin.students}`} readOnly />
                        <label>عدد المساعدين</label>
                        <input type="text" value={`${admin.currentAssistants}/${admin.assistants}`} readOnly />
                        {/* <label>المستحقات</label>
                        <input type='text' value={admin.usedCodes}readOnly></input> */}
                        <label>ميعاد تجديد الاشتراك</label>
                        <input style={expiredAdminStyle} type="text" value={admin.expire} readOnly />
                    </div>
                </div>
            </div>

            {showDeletePopup&& (
                <div className="overlay">
                <div className="delete-admin-confirmation">
                    <h3>هل انت متأكد أنك تريد حذف حسابك</h3>
                    <p>سيؤدي هذا الي حذف المواد وكل الدروس والمساعدين ولن تتمكن من استعادة هذه البيانات</p>
                    <p>ايضا لن تستمتع بالمدة المتبقية من الاشتراك</p>
                    <div style={{display:"flex",
                        justifyContent:"space-between",
                        paddingRight:"20%",
                        paddingLeft:"20%"
                    }}>
                        <button className="yes" onClick={() => deleteAdmin()}>حذف</button>
                        <button onClick={() => setShowDeletePopup(false)}>لا</button>
                    </div>
                </div>
                </div>

            )}

            { showUpdateform && (
                <div className="overlay">
                            <div className="edit-admin-form admin-edit-form">
                                <h3>تعديل البيانات</h3>
                                <label>الاسم</label>
                                <input
                                    type="text"
                                    dir="rtl"
                                    lang="ar"
                                    value={editAdmin.name}
                                    onChange={(e) => setEditAdmin({ ...editAdmin, name: e.target.value })}/>
                                <label>التخصص</label>
                                <input
                                    type="text"
                                    dir="rtl"
                                    lang="ar"
                                    maxLength={50}
                                    value={editAdmin.field}
                                    onChange={(e) => setEditAdmin({ ...editAdmin, field: e.target.value })}/>
                                <label>رقم الهاتف</label>
                                <input
                                    type="text"
                                    dir="rtl"
                                    lang="ar"
                                    maxLength={11}
                                    value={editAdmin.phone}
                                    onChange={(e) => setEditAdmin({ ...editAdmin, phone: e.target.value })}/>

                                <div className="edit-admin-buttons-div">     
                                    <button className="update-admin-button" onClick={updateAdmin}>تحديث</button>
                                    <button id="cancel-update-admin-info" onClick={() => setShowUpdateForm(false)}>إلغاء</button>
                                </div>
                            </div>
                            </div>
                        )}

            { showUpdatePassword && (
                <div className="overlay">
                <div className="edit-admin-form admin-edit-form">
                    <h3>تحديث كلمة المرور</h3>
                    <label>كلمة المرور القديمة</label>
                    <input
                        type="password"
                        value={newPassword.oldPassword}
                        onChange={(e) => setNewPassword({ ...newPassword, oldPassword: e.target.value })}/>
                    <label>كلمة المرور الجديدة</label>
                    <input
                        type="password"
                        value={newPassword.newPassword}
                        onChange={(e) => setNewPassword({ ...newPassword, newPassword: e.target.value })}/>
                    
                    <label>تأكيد كلمة المرور</label>
                    <input
                        type="password"
                        value={newPassword.confirmPassword}
                        onChange={(e) => setNewPassword({ ...newPassword, confirmPassword: e.target.value })}/>

                    <div className="edit-admin-buttons-div">     
                        <button className="update-admin-button" onClick={updatePassword}>تحديث</button>
                        <button id="cancel-update-admin-info" onClick={() => {setShowUpdatePassword(false);setNewPassword({oldPassword:"",newPassword:"",confirmPassword:""})}}>إلغاء</button>
                    </div>
                </div>
                </div>
            )}

            { showMessage && (
                <div className="overlay">
                <div className="home-owner-message">
                    <p>{message}</p>
                    <button onClick={() => {setShowMessage(false);setMessage("")}}>اغلاق</button>
                </div>
                </div>
            )}
        </div>
    )

}